module.exports = __webpack_public_path__ + "img/bg-01.3dd26d7f.jpg";